<template>
  <div class="sky" />
</template>
<script>
export default {
  props: {
    scrollPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      cloudPos: 0,
      scrollSpeed: 0.01,
    };
  },
  watch: {
    scrollPosition() {
      this.cloudPos = (this.scrollPosition * this.scrollSpeed) * -1;
    },
  },
};
</script>

<style lang="scss" scoped>
  .sky {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sky.vue